import React from 'react';
import { Globe, Handshake, DollarSign, Building2, AlertCircle, ArrowRight } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { servicePillars } from '../data/mock';

const iconMap = {
  Globe: Globe,
  Handshake: Handshake,
  DollarSign: DollarSign,
  Building2: Building2,
  AlertCircle: AlertCircle
};

export const ServicesSection = () => {
  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-[#0f3f5d] mb-4">
            Comprehensive Advisory Services
          </h2>
          <p className="text-xl text-gray-600">
            End-to-end solutions for successful cross-border business operations
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {servicePillars.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            
            return (
              <Card 
                key={service.id}
                className="group hover:shadow-xl transition-all duration-300 border-t-4 border-t-[#c2983e] hover:-translate-y-2"
              >
                <CardHeader>
                  <div className="w-16 h-16 rounded-full bg-[#508f9d]/10 flex items-center justify-center mb-4 group-hover:bg-[#508f9d] transition-colors">
                    <IconComponent className="w-8 h-8 text-[#508f9d] group-hover:text-white transition-colors" />
                  </div>
                  <CardTitle className="text-xl text-[#0f3f5d] group-hover:text-[#8b2e4a] transition-colors">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <ul className="space-y-3">
                    {service.services.map((item, idx) => (
                      <li key={idx} className="flex items-start">
                        <ArrowRight className="w-4 h-4 text-[#c2983e] mr-2 mt-1 flex-shrink-0" />
                        <span className="text-gray-700 text-sm">{item}</span>
                      </li>
                    ))}
                  </ul>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* CTA Card */}
        <div className="mt-16 bg-gradient-to-r from-[#508f9d] to-[#8b2e4a] rounded-2xl p-8 lg:p-12 text-center text-white">
          <h3 className="text-3xl font-bold mb-4">Ready to Expand Your Global Reach?</h3>
          <p className="text-lg mb-6 opacity-90">
            Let's discuss how our advisory services can help you achieve your international business goals.
          </p>
          <button 
            onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            className="bg-white text-[#8b2e4a] px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-colors inline-flex items-center"
          >
            Schedule a Consultation
            <ArrowRight className="ml-2 w-5 h-5" />
          </button>
        </div>
      </div>
    </section>
  );
};
